import { Button, Dropdown, Flex, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/img/logo.png';
import LightLogo from '../../assets/img/Prefectos-light.png';
import { useDarkMode } from '../../context/DarkModeContext';
import useAuth from '../../hooks/useAuth';
import { getFullName, handleLogout } from '../../utils';
import UserAvatar from '../UserAvatar';
import AsideDrawer from '../AsideDrawer';
import { Grip } from 'lucide-react';

const Header = ({ isSideBarOpen, onSiderBarToggle }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { isDarkMode } = useDarkMode();

  const renderBranding = () => {
    return (
      <div className="Header__BrandArea">
        <Grip className="hamburger" onClick={onSiderBarToggle} />
        <div className="brand-logo">
          <img
            width={150}
            src={isDarkMode ? LightLogo : Logo}
            alt="Compliance Tracer"
            onClick={() => navigate('/chat')}
          />
        </div>
      </div>
    );
  };

  const items = [
    {
      key: 'profile',
      label: (
        <Flex align="center" gap={10} onClick={(e) => e.stopPropagation()}>
          <UserAvatar user={user} size={40} />
          <Space direction="vertical" size={0}>
            <Typography.Text strong>{getFullName(user)}</Typography.Text>
            <Typography.Text type="secondary">{user?.email ?? user?.username}</Typography.Text>
          </Space>
        </Flex>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: (
        <Flex justify="center">
          <Button type="link" danger>
            Logout
          </Button>
        </Flex>
      ),
      onClick: handleLogout,
    },
  ];

  return (
    <header className="Header">
      {renderBranding()}
      <div className="Header__ProfileArea">
        {/* <Notifications /> */}
        <Dropdown
          menu={{
            items,
          }}
          trigger={['click']}
        >
          <div>
            <UserAvatar user={user} />
          </div>
        </Dropdown>
      </div>
      <AsideDrawer
        open={isSideBarOpen}
        onClose={onSiderBarToggle}
        branding={renderBranding()}
      />
    </header>
  );
};

export default Header;
